import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../../lib/styles/props/component-style-props";
import React from "react";
import {
  ComponentMultiStyleConfig,
  Flex,
  Icon,
  Text,
  useMultiStyleConfig,
} from "@chakra-ui/react";
import { CgShapeRhombus } from "react-icons/cg";
import { CMButtonFormCommentProps, CMFormControlHeader } from "../../../index";
import { isNullish } from "../../../../../lib/util/common-util";

export type CMFileUploadTitleProps = {
  title?: string;
  commentButtonProps?: CMButtonFormCommentProps;
} & ComponentStyleProps;

export const CMFileUploadTitle = ({
  title,
  commentButtonProps,
  sx,
  ...rest
}: CMFileUploadTitleProps) => {
  const styles = useMultiStyleConfig("CMFileUploadTitleStyles");
  return (
    <Flex direction={"row"} sx={{ ...styles.container, ...sx }} {...rest}>
      {isNullish(title) || title === "" ? null : (
        <Icon as={CgShapeRhombus} sx={styles.icon} />
      )}
      <Text sx={styles.title}>{title}</Text>
      <CMFormControlHeader<string>
        value={null}
        commentButtonProps={commentButtonProps}
        sx={styles.button}
      />
    </Flex>
  );
};

export const CMFileUploadTitleStyles: ComponentMultiStyleConfig = {
  parts: ["container", "icon", "title", "button"],
  baseStyle: {
    container: {
      alignItems: "center",
    },
    icon: {
      mr: "8px",
    },
    title: {
      width: "fit-content",
      color: "grey.900",
      whiteSpace: "pre-wrap",
    },
    button: {
      ml: "8px",
    },
  },
};
